import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Dictionary } from 'vue-router/types/router';
import { Form as ElForm, Input } from 'element-ui';
import { authService } from '@/modules/account/services/authService';
import { anagraficaService } from '@/modules/anagrafica/services/anagraficaService';
import { validateItalianFiscalCode, validatePassword } from '@/utils/validate';
import settings from '@/settings';
import { accountServices } from '../services/accountService';
import moment from 'moment';

@Component({
  name: 'Login'
})
export default class extends Vue {
  private loginForm: account.login = {
    userName: null,
    password: null
  };

  giornalista: boolean = true;

  get loginRules() {
    return {
      userName: [
        {
          required: true,
          message: `${this.$t('login.required.username')}`,
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`${this.$t('login.required.password')}`));
            } else if (!validatePassword(value)) {
              callback(new Error(`${this.$t('login.required.passwordPattern')}`));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }
      ]
    };
  }

  private passwordType = 'password';
  private loading = false;
  private showDialog = false;
  private capsTooltip = false;
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};
  private spidProvidersVisible = false;
  private spidProviders: account.spidProvider[] = [];

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  private frontendVersion: string = null;
  private serverVersion: string = null;
  async mounted() {
    if (this.loginForm.userName === '') {
      (this.$refs.userName as Input).focus();
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus();
    }

    this.popupelezioni();

    try {
      this.spidProviders = await authService.GetSPIDProviders();
    } catch {
      console.warn('No SPID provider found');
    }

    (
      await fetch('/version.txt', {
        mode: 'no-cors' // 'cors' by default
      })
    )
      .text()
      .then(t => {
        this.frontendVersion = t;
      })
      .catch(() => console.warn('Versione FrontEnd non trovata'));

    (
      await fetch(`${settings.baseUrl}/version.txt`, {
        mode: 'no-cors' // 'cors' by default
      })
    )
      .text()
      .then(t => {
        this.serverVersion = t;
      })
      .catch(() => console.warn('Versione FrontEnd non trovata'));
  }

  popupelezioni() {
    let showpopup =
      (moment().isAfter(new Date('2025-03-25T10:00:00.000+01:00')) && moment().isBefore('2025-03-25T12:30:00.000+01:00')) ||
      (moment().isAfter(new Date('2025-03-11T17:00:00.000+01:00')) && moment().isBefore('2025-03-13T20:05:00.000+01:00')) ||
      (moment().isAfter(new Date('2025-03-18T17:00:00.000+01:00')) && moment().isBefore('2025-03-20T20:05:00.000+01:00')) ||
      (moment().isAfter(new Date('2025-04-01T17:00:00.000+02:00')) && moment().isBefore('2025-04-03T20:05:00.000+02:00'));

    if (showpopup)
      this.$confirm(
        `
        <style>
          .elezioni {
            width: 630px;
          }

          .elezioni a {
            display: block;
            background: blue;
            padding: 10px;
            width: 70%;
            align-content: center;
            color: white;
            font-weight: 700;
            text-align: center;
            align-self: anchor-center;
            border-radius:4px;
          }

          h1,h3{
          align-self: anchor-center;
          }
        
        </style>
      <div style="display:flex; flex-flow:column">
        <h1>Speciale Elezioni 2025</h1>
        <span>Le elezioni per il rinnovo degli organi dell’Ordine dei Giornalisti avranno luogo nelle seguenti date:</span>
        <h3>
          Ballottaggio: 
        </h3>

        <ul>
          <li><b>online:</b> mercoledì 2 aprile e giovedì 3 aprile dalle ore 10 alle ore 20:00</li>
          <li><b>in presenza:</b> domenica 6 aprile (presso i seggi allestiti dall'Ordine regionale)</li>
        </ul>

        <a href="https://oauth2.skyvotecloud.it/index.php?provider=cnog&ret_uri=https%3A%2F%2Fcert.skyvotecloud.it%2Fauth%2FApi%2Fsrc%2Fapp%2Felection%2FfromAuth&method=POST" class="vota">
        Clicca qui per partecipare al voto
        </a>

      </div>
    
    `,
        '',
        {
          confirmButtonText: 'CHIUDI',
          showCancelButton: false,
          // type: 'info',
          dangerouslyUseHTMLString: true, 
          customClass: 'elezioni'
        }
      );
  }

  idProviderEnabled(provider: string) {
    return this.spidProviders.some(p => p.entityName == provider);
  }

  doSpidLogin(provider: string) {
    authService.DoSpidLogin(provider);
  }
  doCieLogin() {
    authService.DoCieLogin();
  }
  private checkCapslock(e: KeyboardEvent) {
    const { key } = e;
    this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = '';
    } else {
      this.passwordType = 'password';
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus();
    });
  }

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        authService
          .Login(this.loginForm)
          .then(result => {
            this.$router.push({
              path: this.redirect || '/',
              query: this.otherQuery
            });
            this.loading = false;
          })
          .catch(e => {
            let error = `${this.$t('login.error')}`;
            if (e.response && e.response.data) {
              error = e.response.data.exceptionMessage || e.response.data.message || error;
            }
            this.loading = false;
            this.$msgbox({
              title: `Attenzione!`,
              message: error,
              showClose: true,
              dangerouslyUseHTMLString: true,
              type: 'error'
            });
          });
      }
    });
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as Dictionary<string>);
  }

  recoverPassword() {
    this.$router.push({ path: '/recoverPassword' });
  }

  register() {
    this.$prompt(
      `Inserisci il Codice Fiscale per verificare la presenza dell'anagrafica nell'archivio dei giornalisti del CNOG`,
      `Registrati inserendo il Codice Fiscale`,
      {
        confirmButtonText: `Avanti`,
        cancelButtonText: 'Annulla',
        inputValidator: this.validateFiscalCode,
        inputPlaceholder: 'Inserisci il Codice Fiscale'
      }
    )
      .then(async ({ value }: any) => {
        const accountExsist = await accountServices.CheckUsernameExist(value);
        if (accountExsist) {
          this.$alert(`Il Codice Fiscale inserito <i>${value}</i> è già registrato a "formazionegiornalisti.it"`, 'Attenzione!', {
            confirmButtonText: 'Ok',
            type: 'warning',
            dangerouslyUseHTMLString: true
          });
          return;
        }

        const giornalista = await anagraficaService.DetailByCodiceFiscale(value);
        if (giornalista) this.$router.push({ name: 'register', params: { codiceFiscale: value } });
        else
          this.$alert(
            `Il Codice Fiscale inserito <i>${value}</i> non è presente nell'archivio dei giornalisti del CNOG.<br>
          Contatta il tuo ordine Regionale per poter completare correttamente la registrazione.`,
            'Attenzione!',
            {
              confirmButtonText: 'Ok',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }
          );
      })
      .catch(() => {});
  }

  private validateFiscalCode(value): boolean | string {
    if (!value || value.replace(/\s+/, '').length <= 0) return `Il campo 'Codice Fiscale' non può essere vuoto`;
    if (!validateItalianFiscalCode(value)) return `Il campo 'Codice Fiscale' è errato`;
    return true;
  }

  toggleSpidVisible() {
    if (this.spidProvidersVisible) {
      this.spidProvidersVisible = !this.spidProvidersVisible;
      return;
    }

    var ul = this.$refs.spidProviders as HTMLUListElement;
    for (var i = Array.from(ul.children).filter(f => f.className === 'spid-idp-button-link').length; i >= 0; i--) {
      ul.prepend(Array.from(ul.children).filter(f => f.className === 'spid-idp-button-link')[(Math.random() * i) | 0]);
    }
    this.spidProvidersVisible = !this.spidProvidersVisible;
  }
}
